var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../Fct/createPlugin';
import { FctAnyType, FctString } from '../../../Fct/generics';
var MAX_PARAMS_AMOUNT = 30;
var getInputParams = function () {
    var inputParams = {};
    for (var i = 0; i < MAX_PARAMS_AMOUNT; i++) {
        var index = String(i + 1);
        var paramLabelKey = "key".concat(index);
        var paramValueKey = "value".concat(index);
        inputParams[paramLabelKey] = new FctString({ required: false, mode: 'INPUT', hidden: i > 0 });
        inputParams[paramValueKey] = new FctAnyType({ required: false, mode: 'INPUT', hidden: i > 0 });
    }
    return inputParams;
};
var getOutputParams = function () {
    var outputParams = {};
    for (var i = 0; i < MAX_PARAMS_AMOUNT; i++) {
        var index = String(i + 1);
        outputParams["responseValue".concat(index)] = new FctAnyType({ required: false, hidden: i > 0 });
    }
    return outputParams;
};
var getDeps = function () {
    var depParamKeys = [];
    for (var i = 0; i < MAX_PARAMS_AMOUNT; i++) {
        var index = String(i + 1);
        var paramLabelKey = "key".concat(index);
        var paramValueKey = "value".concat(index);
        depParamKeys.push(paramLabelKey);
        depParamKeys.push(paramValueKey);
    }
    return depParamKeys;
};
export var GetOffchainData = createPlugin({
    protocol: 'FUNCTIONS',
    type: 'GETTER',
    method: 'getOffchainData',
    name: 'getOffchainData',
    flowType: 'OFFCHAIN_ONLY',
    getParams: function () { return ({
        input: __assign(__assign({ endpoint: new FctString({ required: false, mode: 'INPUT' }) }, getInputParams()), { methodParams: {} }),
        output: __assign({}, getOutputParams()),
    }); },
    calculateValuesOnUserInput: function (_a) {
        var input = _a.input, output = _a.output;
        var getResponse = function (_a) {
            var service = _a.service;
            return __awaiter(void 0, void 0, void 0, function () {
                var endpoint, getParamValue, query, i, prevIndex, paramIndex, currentKeyParam, currentValueParam, prevKeyParam, prevValueParam, response, data, i, paramIndex, valueParamLabel, param;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!service)
                                return [2 /*return*/, { params: {}, error: 'service is not available' }];
                            if (!service.getData)
                                return [2 /*return*/, { params: {}, error: 'service to get off-chain data is not available' }];
                            endpoint = input.endpoint;
                            getParamValue = function (param) {
                                if (param.isVariable)
                                    return param.estimatedValue;
                                return param.value;
                            };
                            query = [];
                            for (i = 0; i < MAX_PARAMS_AMOUNT; i++) {
                                prevIndex = String(i);
                                paramIndex = String(i + 1);
                                currentKeyParam = input["key".concat(paramIndex)];
                                currentValueParam = input["value".concat(paramIndex)];
                                if (i > 0) {
                                    prevKeyParam = input["key".concat(prevIndex)];
                                    prevValueParam = input["value".concat(prevIndex)];
                                    if (prevKeyParam.value || prevValueParam.value) {
                                        currentKeyParam.hidden = false;
                                        currentValueParam.hidden = false;
                                    }
                                    else {
                                        currentKeyParam.value = undefined;
                                        currentValueParam.value = undefined;
                                        currentKeyParam.hidden = true;
                                        currentValueParam.hidden = true;
                                    }
                                }
                                if (currentKeyParam.value || currentValueParam.value) {
                                    query.push({ key: getParamValue(currentKeyParam), value: getParamValue(currentValueParam) });
                                }
                            }
                            return [4 /*yield*/, service.getData({
                                    endpoint: endpoint.value,
                                    query: query,
                                })];
                        case 1:
                            response = _b.sent();
                            if (!response.data)
                                return [2 /*return*/, { params: {}, error: 'request off-chain data error' }];
                            data = response.data;
                            for (i = 0; i < MAX_PARAMS_AMOUNT; i++) {
                                paramIndex = String(i + 1);
                                valueParamLabel = "responseValue".concat(paramIndex);
                                if (output[valueParamLabel]) {
                                    if (data[i]) {
                                        param = data[i];
                                        output[valueParamLabel].hidden = false;
                                        output[valueParamLabel].label = param.name || '';
                                        output[valueParamLabel].value = param.value || '';
                                        output[valueParamLabel].rawValue = param.rawValue;
                                        output[valueParamLabel].description = param.description;
                                    }
                                    else {
                                        output[valueParamLabel].hidden = true;
                                        output[valueParamLabel].label = undefined;
                                        output[valueParamLabel].rawValue = undefined;
                                        output[valueParamLabel].description = undefined;
                                    }
                                }
                            }
                            return [2 /*return*/, {
                                    params: {},
                                    error: undefined,
                                }];
                    }
                });
            });
        };
        return {
            get: getResponse,
            depParamKeys: __spreadArray(['endpoint'], __read(getDeps()), false),
        };
    },
});
